import { useQuery } from '@tanstack/react-query';
import { useDataChainId } from '@ui/hooks/datachain';
import { Address } from 'viem';
import { usePublicClient } from 'wagmi';

import { getPairMaxTpRatiosQuery } from './query';

export const useGetPairMaxTpRatios = ({ pairBase }: { pairBase: Address }) => {
  const chainId = useDataChainId();
  const client = usePublicClient({
    chainId,
  });

  return useQuery({
    enabled: !!client?.uid,
    queryKey: getPairMaxTpRatiosQuery.getQueryKey({
      pairBase: pairBase,
      clientUid: client?.uid || '',
    }),
    queryFn: getPairMaxTpRatiosQuery.getQueryFn({
      client: client,
      pairBase: pairBase,
      chainId,
    }),
  });
};
